export const GET_DASHBOARD_USER_REQUEST = "GET_DASHBOARD_USER_REQUEST"
export const GET_DASHBOARD_USER_SUCCESS = "GET_DASHBOARD_USER_SUCCESS"
export const GET_DASHBOARD_USER_FAIL = "GET_DASHBOARD_USER_FAIL"

export const GET_DASHBOARD_WEB_REQUEST = "GET_DASHBOARD_WEB_REQUEST"
export const GET_DASHBOARD_WEB_SUCCESS = "GET_DASHBOARD_WEB_SUCCESS"
export const GET_DASHBOARD_WEB_FAIL = "GET_DASHBOARD_WEB_FAIL"

export const CLEAR_ERROR = "CLEAR_ERROR"